const MoreDetailsModal = ({ onClose, data, type, rawData, onImport }) => {
  if (!data) return null;

  const title = type === "officer" ? "Officer Details" : "PSC Details";
 const excludedFields = {
    officer: ["links", "is_pre_1992_appointment"],
    psc: ["etag", "links", "name_elements"]
  };

  const currentExcludes = excludedFields[type] || [];
const headers = data?.items?.length
    ? Object.keys(data.items[0]).filter((key) => !currentExcludes.includes(key))
    : [];

  const formatHeader = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const renderTableRows = () => {
    const list = Array.isArray(data?.items) ? data.items : [];

    if (list.length === 0) {
      return (
        <tr>
          <td colSpan={headers.length}>No data found.</td>
        </tr>
      );
    }


  return list.map((item, index) => (
      <tr key={index}>
        {headers.map((key, i) => (
          <td key={i}>
            {typeof item[key] === "object" ? JSON.stringify(item[key]) : item[key]}
          </td>
        ))}
      </tr>
    ));
  };

  


  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <span className="modal-close" onClick={onClose}>&times;</span>
        <h3 className="modal-title">{title}</h3>

        <div className="table-vertical-scroll">
          {headers.length ? (
            <table className="Detail-result-table">
              <thead>
  <tr>
    {headers.map((header, idx) => (
      <th key={idx}>{formatHeader(header)}</th>
    ))}
  </tr>
</thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
          ) : (
            <p>No details available.</p>
          )}
        </div>

        <div style={{ marginTop: '1rem', textAlign: 'right', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          {onImport && (
            <button
              className="primary-btn"
              onClick={() => onImport(rawData)}
            >
              {type === "officer" ? "Import Management Records" : "Import UBO Records"}
            </button>
          )}
          <button className="primary-btn" onClick={onClose}>Close</button>
        </div>

        <style>{`
          .modal-overlay {
            position: fixed;
            inset: 0;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 999;
          }

          .modal-container {
            background-color: #fff;
            width: 90vw;
            max-height: 90vh;
            border-radius: 8px;
            padding: 24px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
            overflow-y: auto;
            position: relative;
          }

          .modal-close {
            position: absolute;
            top: 12px;
            right: 16px;
            font-size: 22px;
            font-weight: bold;
            color: #555;
            cursor: pointer;
          }

          .modal-title {
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 16px;
          }

          .table-vertical-scroll {
            max-height: 60vh;
            overflow-y: auto;
            margin-top: 1rem;
            border: 1px solid #ccc;
            border-radius: 6px;
          }

          .Detail-result-table {
            width: 100%;
            border-collapse: collapse;
          }

        .Detail-result-table th,
.Detail-result-table td {
  padding: 8px 12px;
  border: 1px solid #ddd;
  font-size: 14px;
  text-align: left;
  vertical-align: top;

  word-break: normal;          /* Prevent breaking in middle of words */
  overflow-wrap: anywhere;   /* Allow wrapping at spaces or hyphens */
  white-space: normal;         /* Allow multi-line content */
}


          .Detail-result-table th {
            background-color: #f0f0f0;
            font-weight: 600;
          }

          .primary-btn {
            padding: 8px 14px;
            background-color: #07b1b0;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }

          .primary-btn:hover {
            background-color: #059a9a;
          }
        `}</style>
      </div>
    </div>
  );
};

export default MoreDetailsModal;
